import React, { useRef, useState } from 'react'
import { Form, Modal, Row,Button as ButtonBootstrap } from 'react-bootstrap'
import { Eye, EyeSlash } from 'react-bootstrap-icons'
import CircleSign from './CircleSign'
import { useImperativeHandle } from 'react'
import { forwardRef } from 'react'
import { toast } from 'react-toastify'
import { config } from '../../constants'
import history from "../history";
import ConfirmationModal from '../ui/ConfirmationModal';
import apiClient from '../../utils/apiClient';

const url = config.url.URL;

const SetNewPass = forwardRef(({msgContaint, isLogin }, ref) => {

    const [showChangePasswordModal, setshowChangePasswordModal] = useState(false);
    const [newPassword, setNewPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [curPassword, setPassword] = useState('');
    const [showNewPassword, setShowNewPassword] = useState(false);
    const [passNewVal, setPassNewVal] = useState(true);
    const [passConfNewVal, setPassConfNewVal] = useState(true);
    const [textError, settextError] = useState("Required");
    const [textError2, settextError2] = useState("Required");
    const [showConfirmationModal, setShowConfirmationModal] = useState(false); 

    const password = useRef();
    const conpassword = useRef();

    const openChangePasswordModal = () => {
      setshowChangePasswordModal(!showChangePasswordModal);
      setNewPassword("");
      setPassword("");
      setPassNewVal(true);
      setPassConfNewVal(true);
      setShowPassword(false);
      setShowNewPassword(false);
    };
    const requestCloseChangePasswordModal = () => {
      setShowConfirmationModal(true);
    };
    const doubleCloseModals = () => {
      setshowChangePasswordModal(false);
      setShowConfirmationModal(false);
    };
    
    const closeConfirmationModal = () => {
      setShowConfirmationModal(false);
    };

    const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const toggleNewPasswordVisibility = () => {
    setShowNewPassword(!showNewPassword);
  };

  const passwordHandler = (e)=> {
    setPassword(e.target.value);
  };

  const newPasswordHandler = (e)=> {
    setNewPassword(e.target.value);
  };

  const savePassword = async () => { 
    console.log(password.current.value);
    console.log(conpassword.current.value);


    if (password.current.value == ""){
      setPassNewVal(false)
      settextError("Required");
    }else{
      setPassNewVal(true)
    }
    if (conpassword.current.value == ""){
      setPassConfNewVal(false)
      settextError2("Required");
    }else{
      setPassConfNewVal(true)
    }

    if(password.current.value == "" || conpassword.current.value == ""){
      return;
    }

    if(password.current.value != conpassword.current.value){
      setPassConfNewVal(false)
      settextError2("Password confirmation doesn`t match password");
      return;
    }

    const passwordData = {
      email: localStorage.getItem("email"),
      newPassword: password.current.value
    };

    try {
        const response = await fetch(`${url}/login/ChangePassword`, {
            method: 'POST',
            headers: {
              'accept': 'application/json',
              'content-type': 'application/json',
          },
            body: JSON.stringify(passwordData)
        });
        
        var json = await response.clone().json();
        if (json.statusCode == 406){
          setPassNewVal(false)
          settextError(json.headers[0].value[0]);
        }
        else if (json.statusCode == 500){
          toast.error(json.headers[0].value[0]);
        }
        else if(json.statusCode == 200){
          toast.success(json.headers[0].value[0]);

          if(isLogin){
            toast.success("Successful Login");

            let unblock = history.block();
            unblock();
    
            setTimeout(function () {
                history.push("/signinprofile");
            }, 1000);

          }else{
            openChangePasswordModal();
          }
        }
        else{
          toast.error(json.headers[0].value[0]);
          setPassNewVal(true)
        }
    } catch (error) {
      toast.error("Your password could not be changed, please try again. In case of new failure, please contact your support.");
    }
  };

    // Expose the function through the ref
    useImperativeHandle(ref, () => ({
        openChangePasswordModal,
        showChangePasswordModal
      }));

  return (
    <><Modal
      show={showChangePasswordModal}
      onHide={requestCloseChangePasswordModal}
      size="xs"
    >
      <Modal.Header closeButton>
        <Modal.Title size="h6">Set new password</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {msgContaint}<br />
        <br />
        <Row>
          <Form.Group className="mb-3 col-md-12" controlId="password">
            <Form.Label className={`${passNewVal ? "normal-title" : "validation-title"} margin-bot-1`}>New password <CircleSign /></Form.Label>
            <div style={{ display: "flex", position: "relative" }}>

              <Form.Control
                type={showPassword ? "text" : "password"}
                value={curPassword}
                ref={password}
                autoComplete="new-password"
                className={`${!passNewVal && "validation-control"}`}
                onChange={(e) => passwordHandler(e)}
                placeholder="New password" />
              <div className="eye-pos">
                {showPassword ? (
                  <EyeSlash fill="blue" onClick={togglePasswordVisibility} />
                ) : (
                  <Eye fill="blue" onClick={togglePasswordVisibility} />
                )}
              </div>
            </div>
            {!passNewVal && <p className="p-required" style={{ marginBottom: '0' }}>{textError}</p>}

          </Form.Group>
        </Row>

        <Row>
          <Form.Group className="mb-3 col-md-12" controlId="conpassword">
            <Form.Label className={`${passConfNewVal ? "normal-title" : "validation-title"} margin-bot-1`}>Confirm password <CircleSign /></Form.Label>
            <div style={{ display: "flex", position: "relative" }}>

              <Form.Control
                type={showNewPassword ? "text" : "password"}
                value={newPassword}
                ref={conpassword}
                autoComplete="new-password"
                className={`${!passConfNewVal && "validation-control"}`}
                onChange={(e) => newPasswordHandler(e)}
                placeholder="Confirm password" />
              <div className="eye-pos">
                {showNewPassword ? (
                  <EyeSlash fill="blue" onClick={toggleNewPasswordVisibility} />
                ) : (
                  <Eye fill="blue" onClick={toggleNewPasswordVisibility} />
                )}
              </div>
            </div>
            {!passConfNewVal && <p className="p-required" style={{ marginBottom: '0' }}>{textError2}</p>}
          </Form.Group>
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <ButtonBootstrap
          variant="primary"
          className="btnPrimary"
          onClick={savePassword}
        >
          Save
        </ButtonBootstrap>
        <ButtonBootstrap
          variant="secondary"
          className="btnSecondary"
          onClick={requestCloseChangePasswordModal}
        >
          Cancel
        </ButtonBootstrap>
      </Modal.Footer>
    </Modal>
    <ConfirmationModal 
      show={showConfirmationModal}
      hide={closeConfirmationModal} 
      doubleCloseModals={doubleCloseModals} 
      msg="Your updates won't be saved. Are you sure you want to leave this page ?" /></>      
  )
})

export default SetNewPass